<script></script>

<div class="content">
    <h1>¡Bienvenido a Catequizar.org!</h1>

    <h3>Deuteronomio 6:4-9</h3>
    <p>
        Escucha, oh Israel, el Señor es nuestro Dios, el Señor uno es. Amarás al
        Señor tu Dios con todo tu corazón, con toda tu alma y con toda tu
        fuerza. Y estas palabras que yo te mando hoy, estarán sobre tu corazón;
        y diligentemente las enseñarás a tus hijos, y hablarás de ellas cuando
        te sientes en tu casa y cuando andes por el camino, cuando te acuestes y
        cuando te levantes. Y las atarás como una señal a tu mano, y serán por
        insignias entre tus ojos. Y las escribirás en los postes de tu casa y en
        tus puertas.
    </p>

    <h3>Josué 24:15</h3>
    <p>
        Y si no os parece bien servir al Señor, escoged hoy a quién habéis de
        servir: si a los dioses que sirvieron vuestros padres, que estaban al
        otro lado del Río, o a los dioses de los amorreos en cuya tierra
        habitáis; pero yo y mi casa, serviremos al Señor.
    </p>

    <h3>2 Timoteo 3:16-17</h3>
    <p>
        Toda Escritura es inspirada por Dios y útil para enseñar, para
        reprender, para corregir, para instruir en justicia, a fin de que el
        hombre de Dios sea perfecto, equipado para toda buena obra.
    </p>
</div>

<style></style>
